<template>
  <span>
    <date-picker v-if="this.type === 'fixed'" />
    <picker
      class="ui compact selection dropdown"
      :items="dynamicTimes"
      placeholder="Fixed"
      display-property="name"
      key-property="value"
      @change="updateType"
    />

  </span>
</template>

<script>
import DatePicker from '@/components/shared/DatePicker'
import * as forms from '@/libraries/forms/forms'
import Picker from './Picker'
export default {
  name: 'DynamicDatePicker',
  components: { DatePicker, Picker },
  data () {
    return {
      type: 'fixed',
    }
  },
  computed: {
    dynamicTimes: function () {
      const timeRangeOptions = [
        'Fixed',
        'Dawn',
        'Dusk',
      ]
      const options = timeRangeOptions.map(option => new forms.FormFieldSelectOption(option, option.toLowerCase()))
      return options
    },
  },
  methods: {
    updateType: function (newType) {
      this.type = newType.value
    },
  },
}
</script>

<style scoped>

  .ui.compact.selection.dropdown {
    margin: 1px !important;
    z-index: 999;
  }
</style>
